<template>
  <v-chip small outline>
    <v-avatar>
      <v-icon :color="instanceColor" v-bind="$attrs">{{ icon }}</v-icon>
    </v-avatar>
    {{ $t(status) }}
  </v-chip>
</template>

<script>
const STYLES = {
  active: { icon: 'mdi-check-outline', color: 'success' },
  pending: { icon: 'mdi-clock-outline', color: 'warning' },
  closed: { icon: 'mdi-close-circle-outline', color: 'grey lighten-1' },
  trash: { icon: 'mdi-trash-can-outline', color: 'error' },
};

export default {
  props: ['status', 'color'],
  computed: {
    style() {
      return STYLES[this.status] || STYLES.active;
    },
    icon() {
      return this.style.icon;
    },
    instanceColor() {
      return this.color || this.style.color;
    },
  },
};
</script>
